export default __webpack_public_path__ + "static/media/photo--sm--70.a644a8a7.jpg";